import React, { useState, useEffect } from "react";
import bkgimg from "../assets/HeroImage.png";
import bkgimgMobile from "../assets/HeroImage(Mob).png";

const HeroSection: React.FC = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 620);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setScreenWidth(width);
      setIsMobile(width <= 620);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getBackgroundImage = () => {
    if (screenWidth >= 320 && screenWidth <= 420) {
      return bkgimgMobile;
    }
    return bkgimg;
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <section
      id="hero"
      style={{
        paddingTop: "96px",
        paddingLeft: isMobile ? "16px" : "64px",
        paddingRight: isMobile ? "16px" : "64px",
        backgroundColor: "#ffffff",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1200px",
          position: "relative",
        }}
      >
        <div
          style={{
            width: "100%",
            height: isMobile ? "300px" : "500px",
            borderRadius: "24px",
            overflow: "hidden",
            position: "relative",
            marginBottom: "60px",
            background: `url(${getBackgroundImage()})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background:
                "linear-gradient(45deg, rgba(0,0,0,0.2) 0%, rgba(255,138,0,0.1) 100%)",
            }}
          />
        </div>

        {!isMobile && (
          <div
            style={{
              position: "absolute",
              top: "64px",
              right: "64px",
              textAlign: "right",
              zIndex: 10,
            }}
          >
            <h1
              style={{
                fontSize: "40px",
                fontWeight: "medium",
                color: "white",
                lineHeight: "1.2",
                textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                margin: 0,
              }}
            >
              Powering Logistics
              <br />
              Connecting Markets
              <br />
              Moving Africa Forward
            </h1>
          </div>
        )}

        <div
          style={{
            textAlign: "center",
            maxWidth: "800px",
            margin: "0 auto",
          }}
        >
          <h2
            style={{
              fontSize: isMobile ? "24px" : "36px",
              fontWeight: "bold",
              color: "#1a365d",
              lineHeight: "1.3",
              marginBottom: "12px",
            }}
          >
            Etiti Logistics: Procurement &<br />
            Transport Made Easy
          </h2>

          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              color: "#4a5568",
              opacity: "0.76",
              lineHeight: "1.6",
              marginBottom: "40px",
              maxWidth: "600px",
              margin: "0 auto 40px auto",
            }}
          >
            We streamline supply chain operations for businesses across Nigeria
            and emerging markets. From sourcing quality cargo to managing
            multimodal transport and payments—we do it all with transparency and
            precision
          </p>

          <button
            onClick={() => scrollToSection("get-in-touch")}
            style={{
              backgroundColor: "#04EEAD",
              border: "none",
              padding: "6px 6px 6px 12px",
              borderRadius: "25px",
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "16px",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 15px rgba(4, 238, 173, 0.3)",
              height: "48px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow =
                "0 6px 20px rgba(4, 238, 173, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 4px 15px rgba(4, 238, 173, 0.3)";
            }}
          >
            <span
              style={{
                color: "#1F2937",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "24px",
              }}
            >
              Request a Quote
            </span>
            <span
              style={{
                backgroundColor: "#1F2937",
                borderRadius: "100%",
                width: "36px",
                height: "36px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "16px",
                color: "#ffffff",
                transform: "rotate(-45deg)",
              }}
            >
              →
            </span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
